import { environment } from '@environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class SaveTestService {
    // eslint-disable-next-line
    constructor(http) {
        this.http = http;
    }
    updateTestResults(data) {
        if (data) {
            for (const i in data) {
                if (data[i].answerFms === null) {
                    data[i].answerFms = data[i].answerLuca;
                }
            }
        }
        return this.http.put(environment.api.base + 'efas', data);
    }
}
SaveTestService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SaveTestService_Factory() { return new SaveTestService(i0.ɵɵinject(i1.HttpClient)); }, token: SaveTestService, providedIn: "root" });
